import { QuickStatsCard } from "@shared/components/QuickStatsCard";
import { useCurrency } from "@shared/selectors/globalSelectors";

import { Activity, Landmark, Monitor } from "lucide-react";

export const DrillDownDashboard = ({ data }: { data: any }) => {
  const currency = useCurrency();

  const kpis = [
    {
      title: "System Receipts",
      count: `${currency} ${data?.[0]?.value}`,
      trendSummary: "From bank statement",
      icon: <Monitor className="w-5 h-5 text-gray-500" />,
    },
    {
      title: "Bank Credits",
      count: (
        <span>
          {currency} {data?.[1]?.value}
        </span>
      ),
      trendSummary: "From bank statement",
      icon: <Landmark className="w-5 h-5 text-gray-500" />,
    },
    {
      title: "Variance",
      count: (
        <span>
          {currency} {data?.[2]?.value}
        </span>
      ),
      trendSummary: "Bank short",
      icon: <Activity className="w-5 h-5 text-gray-500" />,
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {kpis.map((kpi, index) => (
        <QuickStatsCard
          key={index}
          title={kpi.title}
          count={kpi.count}
          trendSummary={kpi.trendSummary}
          icon={kpi.icon}
        />
      ))}
    </div>
  );
};
